import React from "react";
import {
  WorkPlanProps,
  WorkPlanContainer,
  KalenderIcon,
  AbfahrtIcon,
  Info,
} from "../../utils/types";
import { AdresseObjektBauleiter } from "./AdresseObjektBauleiter";
import { Monteur } from "./Monteur";
import {
  getArbeitsplanTitle,
  getIsCurrentDateInRange,
} from "../../utils/helperFunctions";
import moment from "moment";
import { ArbeitsplanTitleWithUnderline } from "../../components/common/ArbeitsplanTitleWithUnderline";

export const ArbeitsplanDetailsItem: React.FC<WorkPlanProps> = ({
  workPlan,
  users,
}) => {
  const mitarbeiter = [
    ...new Set(workPlan.mitarbeiter?.split(",").map((x) => x?.trim())),
  ];

  const userList = users.filter((user) =>
    mitarbeiter.includes(String(user.mitarbeiternummer))
  );
  const isCurrentDateInRange = getIsCurrentDateInRange(workPlan);
  const workPlanTitle = getArbeitsplanTitle(workPlan);

  return (
    <WorkPlanContainer
      style={{
        outline: isCurrentDateInRange ? "3px solid #1d9538" : "none",
      }}
    >
      <ArbeitsplanTitleWithUnderline title={workPlanTitle} />

      <Info>
        <div>
          <KalenderIcon />
          {moment(workPlan.datum, "YYYY-MM-DD").format("DD.MM.YYYY")}{" "}
          {workPlan.gesamttermindatumbis &&
            workPlan.gesamttermindatumbis != workPlan.gesamttermindatumvon &&
            ` - ${moment(workPlan.gesamttermindatumbis, "YYYY-MM-DD").format("DD.MM.YYYY")}`}
        </div>
        <div>
          <AbfahrtIcon />
          Abfahrt {workPlan.zeitvon.replace(new RegExp(":[0-9]*.0000000"), "")}
        </div>
        <Monteur userList={userList} />
      </Info>

      <p>
        {workPlan.bemerkung?.split("\\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
      <AdresseObjektBauleiter workPlan={workPlan} users={users} />
    </WorkPlanContainer>
  );
};
